import { memo } from "react";
import * as css from "./widget-resume-reminder.module.css";

/**
 * Compact bottom-right affordance shown when the merchant has an
 * in-progress setup row (intake not yet completed) and is currently on
 * a route OUTSIDE that product's `routePattern`.
 *
 * The intake modal itself is route-scoped — it would feel intrusive on
 * unrelated pages. This reminder takes its place: a single tap-target
 * routing the merchant back into the product's home where the modal
 * naturally renders.
 *
 * Display name + click handler are passed in by the host so this stays
 * fully product-agnostic.
 */
export const WidgetResumeReminder = memo(function WidgetResumeReminder({
  displayName,
  onClick,
}: {
  displayName: string;
  onClick: () => void;
}) {
  return (
    <button className={css.reminder} onClick={onClick} type="button">
      <span className={css.label}>Resume {displayName}</span>
      <span aria-hidden className={css.arrow}>
        →
      </span>
    </button>
  );
});
